import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useIsPermalinkPage } from '../../../utils/session/permalinkToken'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useOpenEditUsersModal } from '../../../utils/routes/modals/modalsActions'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text, { Title } from '../../../packages/kiti/components/presentation/Text'

const ModalHeader = () => {
  const { t } = useTranslation('editUser')
  const { id, onSave } = useModalData() || {}
  const isEditing = id > 0
  const isPublic = useIsPermalinkPage()
  const canUseBulk = !isPublic && !isEditing && !onSave
  const context = isEditing && 'edit'
  const title = t('title', { context })
  const openBulkModal = useOpenEditUsersModal()

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <Title size="h5" bold>
            {title}
          </Title>
        </Col>
        {canUseBulk && (
          <Col>
            <Text color="primary" size="xsmall" bold onClick={openBulkModal}>
              {t('bulkEdit')}
            </Text>
          </Col>
        )}
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
